export default __webpack_public_path__ + "static/media/Illustration4.21cedbff.png";